import styled from 'styled-components/macro';

import MapirLoader from './mapir-loader';

const Container = styled.section`
  width: 100%;
  height: 100%;
  padding: 3em;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--shade-5);
  z-index: 100;
`;

const Quote = styled.figure`
  direction: ltr;
`;
const Text = styled.blockquote`
  font-size: 2em;
  margin: 40px 0;
`;
const Author = styled.figcaption`
  text-align: end;
  font-weight: 200;
`;

function FullPageLoader({ className, quote }: any): any {
  return (
    <Container className={[className, 'loader-wrapper'].join(' ')}>
      <MapirLoader />
      {quote ? (
        <Quote>
          <Text>To be, or not to be: that is the question</Text>
          <Author>
            {' '}
            &mdash; Shakespeare, <cite>Hamlet</cite>
          </Author>
        </Quote>
      ) : null}
    </Container>
  );
}

export default FullPageLoader;
